import { useEffect, useState } from "react";

export function useVisibility(ref: React.RefObject<Element>): boolean {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "0px 0px -100px 0px",
        threshold: 0.01, // Smaller threshold for faster detection
      }
    );

    observer.observe(node);

    return () => {
      observer.unobserve(node);
      observer.disconnect();
    };
  }, [ref.current]); // Listen specifically to ref.current changes

  return isVisible;
}